export default "__VITE_ASSET__BNrkSFYQ__"